import MidlistYandex from '../ad/desktop/midlist_yandex.js.jsx';
import MidlistGoogle from '../ad/mobile/midlist_google.js';
import CampsListMain from '../camp_list_main.js';
import CampCard from './camp_card/camp_card.js.jsx';

export default class CampList extends CampsListMain {
  _renderAd() {
    return [
      <MidlistYandex
        show_ads={this.props.show_ads}
        number_of_camps={this.props.camps.length}
        camps_required={this.numberOfCampsRequiredToShowMidAds}
      />,
      <MidlistGoogle show_ads={this.props.show_ads} />,
    ];
  }

  _renderCampCard(camp) {
    const camp_lazy_information = camp;
    let is_nofollow = !camp.is_indexed_on_website;

    const props = {
      filter_params: this.props.filter_params,
      key: camp.id,
      data: camp,
      region_work_with: this.props.region_work_with,
      have_autocompleted_price: this.props.have_autocompleted_price,
      show_outdated_price: this.props.show_outdated_price,
      count_guests: camp.withLessCapacity ? this.props.fewerCountGuests() : this.props.count_guests,
      children_ages: camp.withLessCapacity ? [] : this.props.children_ages,
      delta_days: this.props.delta_days,
      showMapCamp: this.props.showMapCamp,
      display_calculated_price: this.props.display_calculated_price,
      showContractPercent: this.props.showContractPercent,
      showCommission: this.props.showCommission,
      filters: this.props.filters,
      apartments: (camp_lazy_information != null ? camp_lazy_information.apartments : undefined) || [],
      count_apartments: camp_lazy_information != null ? camp_lazy_information.count_apartments : undefined,
      pictures: this.props.showAllCamps
        ? camp.pictures
        : (camp_lazy_information != null ? camp_lazy_information.pictures : undefined) || [],
      filter_alt_img: this.props.showAllCamps
        ? camp.filter_alt_img
        : camp_lazy_information != null
          ? camp_lazy_information.filter_alt_img
          : undefined,
      allCampsLoaded: this.props.campsLoaded && !this.props.showingInitialCamps,
      is_nofollow: is_nofollow,
      show_all_camps: this.props.showAllCamps,
      isFavorite: this.props.favorites.includes(camp.id),
      campsLoaded: this.props.campsLoaded,
      filter_values: this.props.filter_values,
      toggleFavoriteCamp: this.props.toggleFavoriteCamp,
      nearbyCamps: this.props.nearbyCamps,
    };
    return <CampCard {...props} />;
  }
}
